/**
 * EDIT THIRD PARTY REDUX REDUCERS
 *
 * @version 0.1
 */

const LOAD_COMPANY_DATA = "LOAD_COMPANY_DATA";

function editThirdParty(state = null, action) {

    switch(action.type) {

        case LOAD_COMPANY_DATA:
            return Object.assign(
                {}, state, {
                    companyData: action.payload
                }
            );

        default:
            return state;

    }

}

export default editThirdParty;


// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/EditThirdParty.reducers.js